import {useRef} from 'react'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import * as Yup from 'yup'
import 'bootstrap/dist/css/bootstrap.min.css'
import Astericsign from './Astericsign'
import {emailValidation} from './helper/ValidationHelperComponent'
import PrimaryButton from '../common/buttons/PrimaryButton'

interface FormValues {
  email: string
  name: string
}

interface CreateUserFromProps {
  title?: string
  isOpen: boolean
  onClose: () => void
  isLoading: boolean
  handleSubmit: (values: any, resetForm: () => void) => void
  setFormDirty?: (isDirty: boolean) => void
}

const validationSchema = Yup.object().shape({
  email: emailValidation,
  name: Yup.string().min(2).max(55).required('Name is required'),
})

function CreateUserFrom({
  title,
  isOpen,
  onClose,
  isLoading = false,
  handleSubmit,
}: CreateUserFromProps) {
  const resetFormRef = useRef<(() => void) | null>(null) // Store resetForm function

  // initial values
  const initialValues: FormValues = {
    email: '',
    name: '',
  }

  const handleClose = () => {
    if (resetFormRef.current) {
      resetFormRef.current() // Reset form values & validation errors
    }
    onClose() // Close modal
  }
  return (
    <>
      {/* modal overlay */}
      {isOpen && (
        <div
          onClick={handleClose}
          className='modal-backdrop show'
          style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}
        />
      )}

      <div className={`modal fade ${isOpen ? 'show d-block' : ''}`} tabIndex={-1}>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>{title}</h5>
              <button type='button' className='btn-close' onClick={handleClose}></button>
            </div>
            <div className='modal-body mb-0'>
              <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={validationSchema}
                // validateOnChange={false} // Prevent validation from triggering on change
                validateOnBlur={false} // Prevent validation on blur
                onSubmit={(values, {setSubmitting, resetForm}) => {
                  const normalizedValues = {
                    ...values,
                    email: values.email?.toLowerCase().trim() || '',
                  }
                  handleSubmit(normalizedValues, resetForm)
                  setSubmitting(false)
                }}
              >
                {({isSubmitting, resetForm}) => {
                  resetFormRef.current = resetForm // Store resetForm in ref

                  return (
                    <Form>
                      <div className='mb-3'>
                        <label className='form-label'>
                          Name <Astericsign />
                        </label>
                        <Field name='name' type='text' className='form-control' />
                        <ErrorMessage name='name' component='div' className='text-danger' />
                      </div>
                      <div className='mb-3'>
                        <label className='form-label'>
                          Email <Astericsign />
                        </label>
                        <Field name='email' type='email' className='form-control' />
                        <ErrorMessage name='email' component='div' className='text-danger' />
                      </div>

                      <div className='d-flex justify-content-end align-items-center'>
                        <PrimaryButton className='' disabled={isLoading} type='submit'>
                          {!isLoading && <span className='indicator-label'>Invite</span>}
                          {isLoading && (
                            <span className='indicator-progress' style={{display: 'block'}}>
                              Inviting...
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </PrimaryButton>
                      </div>
                    </Form>
                  )
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateUserFrom
